import api from 'core/api';

export const search = (data) => api.post('/competitions/search', { ...data });
export const recents = (data) => api.get('/competitions/recents', { params: { ...data } });
export const upcoming = (data) => api.get('/competitions/upcoming', { params: { ...data } });
export const current = (data) => api.get('/competitions/current', { params: { ...data } });
